

























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class RadioGroupDialog extends Vue {
  @Prop({ default: "OK" }) buttonOk!: string;
  @Prop({ default: "結果ダウンロード" }) buttonDownload!: string;
  @Prop({ default: "ダウンロード.txt" }) downloadFileName!: string;
  private title = "【タイトル】";
  private message = "message";
  private okcallback: Function | null = null;
  private canDownload = false;

  //開いているかどうか
  private isActive = false;

  //開く
  public open(
    title: string,
    message: string,
    canDownload = false,
    okcallback: Function | null = null
  ) {
    this.title = title;
    this.message = message;
    this.canDownload = canDownload;
    this.okcallback = okcallback;

    this.isActive = true;
  }

  //決定
  private ok() {
    this.isActive = false;
    if (this.okcallback != null) {
      this.okcallback();
    }
  }

  //ダウンロード
  private download() {
    const blob = new Blob([this.message]);
    const a = document.createElement("a");
    a.download = this.downloadFileName;
    a.href = URL.createObjectURL(blob);
    a.click();
  }
}
